import type { DeliveredMessages, Message } from "../API";

export type LegacyMessageListItem = Omit<Message, "body">;

export type DeliveredMessageListItem = Omit<DeliveredMessages, "body">;

export function isMessageEditableByStatus(
  status: string | null | undefined,
): boolean {
  return String(status ?? "").trim().length === 0;
}
